import React from 'react'
import { Link } from 'react-router-dom';

function ServiceOne() {
    return (
        <div>
            <>
                {/* rts service post area Start */}
                <div className="rts-service-area rts-section-gapBottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="rts-title-area service text-center">
                                    <p className="pre-title">Nossas Unidades</p>
                                    <h2 className="title">Soluções Estratégicas GB Partner</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid service-main plr--120-service mt--50 plr_md--0 pl_sm--0 pr_sm--0">
                        <div className="background-service row">

                            {/* CARD 1 – CRÉDITO EMPRESARIAL */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner one">
                                    <div className="thumbnail">
                                        <img src="/assets/images/home/5.png" alt="Crédito Empresarial" />
                                    </div>
                                    <div className="service-details">
                                        <Link to='/servicos/credito-empresarial'>
                                            <h5 className="title">Crédito Empresarial</h5>
                                        </Link>
                                        <p className="disc">
                                            Estruturação e intermediação de operações financeiras sob medida, 
                                            focando em capital de giro, antecipação e acesso a FIDCs.
                                        </p>
                                        <Link className="rts-read-more btn-primary" to='/servicos/credito-empresarial'>
                                            <i className="far fa-arrow-right" /> Saiba Mais
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* CARD 2 – AGRO */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner two">
                                    <div className="thumbnail">
                                        <img src="/assets/images/home/5.png" alt="Agro" />
                                    </div>
                                    <div className="service-details">
                                        <Link to='/servicos/agro'>
                                            <h5 className="title">Agro</h5>
                                        </Link>
                                        <p className="disc">
                                            Soluções de crédito rural, CRA e estruturação financeira para safra, 
                                            conectando o produtor às melhores oportunidades do mercado.
                                        </p>
                                        <Link className="rts-read-more btn-primary" to='/servicos/agro'>
                                            <i className="far fa-arrow-right" /> Saiba Mais
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* CARD 3 – SEGUROS */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner three">
                                    <div className="thumbnail">
                                        <img src="/assets/images/home/5.png" alt="Seguros" />
                                    </div>
                                    <div className="service-details">
                                        <Link to='/servicos/seguros'>
                                            <h5 className="title">Seguros</h5>
                                        </Link>
                                        <p className="disc">
                                            Gestão de riscos e proteção patrimonial completa para ativos 
                                            empresariais e rurais, garantindo a segurança do seu legado.
                                        </p>
                                        <Link className="rts-read-more btn-primary" to='/servicos/seguros'>
                                            <i className="far fa-arrow-right" /> Saiba Mais
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* CARD 4 – CRÉDITO DE CARBONO */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner four">
                                    <div className="thumbnail">
                                        <img src="/assets/images/home/5.png" alt="Crédito de Carbono" />
                                    </div>
                                    <div className="service-details">
                                        <Link to='/servicos/credito-carbono'>
                                            <h5 className="title">Crédito de Carbono</h5>
                                        </Link>
                                        <p className="disc">
                                            Transformamos sustentabilidade em ativo financeiro através da 
                                            modelagem de projetos ambientais e conexão com o mercado global.
                                        </p>
                                        <Link className="rts-read-more btn-primary" to='/servicos/credito-carbono'>
                                            <i className="far fa-arrow-right" /> Saiba Mais
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            {/* CARD 5 – INTELIGÊNCIA DE MERCADO */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner five">
                                    <div className="thumbnail">
                                        <img src="/assets/images/home/5.png" alt="Inteligência de Mercado" />
                                    </div>
                                    <div className="service-details">
                                        <Link to='/servicos/inteligencia-mercado'>
                                            <h5 className="title">Inteligência de Mercado</h5>
                                        </Link>
                                        <p className="disc">
                                            Apoio consultivo com estudos de viabilidade e planejamento 
                                            estratégico para embasar decisões de investimento de alto impacto.
                                        </p>
                                        <Link className="rts-read-more btn-primary" to='/servicos/inteligencia-mercado'>
                                            <i className="far fa-arrow-right" /> Saiba Mais
                                        </Link>
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* CTA FINAL */}
                        <div className="row">
                            <div className="cta-one-bg col-12">
                                <div className="cta-one-inner">
                                    <div className="cta-left">
                                        <h3 className="title">
                                            Fale agora com um especialista e descubra a melhor solução para o seu negócio.
                                        </h3>
                                    </div>
                                    <div className="cta-right">
                                        {/* Link direto para a página de contato do site */}
                                        <Link className="rts-btn btn-white" to="/Contato">
                                            Falar com Especialista
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {/* rts service post area END */}
            </>
        </div>
    )
}

export default ServiceOne;